import { ResponseError } from '../../errors';
import { fetchWebChatsGet, TWebChatsGetRequest, TWebChatsGetResponse } from '../../repositories/chats/v2/web/chats/get';
import { CHATS_ON_PAGE_LIMIT, EFilterBySyncChatSchema, EStatusSyncChatSchema } from '../../types/chatList';
import { TContext } from '../../types/context';
import { ETelemetryEvents } from '../../types/telemetry';
import { mapChatV2VersionToV1 } from '../../utils/v2ToV1/mapChat';

export interface IFetchChatsV2ParamsRequest {
  /** timestamp последнего чата, последней страницы */
  timestamp?: number;
  /** Фильтр для синхронизации чатов **/
  filterBy?: EFilterBySyncChatSchema;
  /** Раздел чатов **/
  status?: EStatusSyncChatSchema;
  subAgentRealtyUserId?: number;
}

type TFetchChatsV2Params = {
  parameters: IFetchChatsV2ParamsRequest;
  cookies?: string;
};

const DOMAIN = 'critical.getChats';

export async function fetchChatsV2(
  { logger, httpApi, telemetry }: TContext,
  { cookies, parameters }: TFetchChatsV2Params,
) {
  const { timestamp, filterBy, status, subAgentRealtyUserId } = parameters;

  const options: TWebChatsGetRequest = {
    limit: CHATS_ON_PAGE_LIMIT,
    minDatetimeForSorting: timestamp ? new Date(timestamp).toISOString() : undefined,
    subAgentRealtyUserId,
    filterBy,
    status: status || EStatusSyncChatSchema.Active,
  };

  const startTime = Date.now();

  telemetry.increment(ETelemetryEvents.ChatsGetInit);

  try {
    const { response, statusCode }: TWebChatsGetResponse = await fetchWebChatsGet({
      httpApi,
      parameters: options,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: DOMAIN,
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    telemetry.increment(ETelemetryEvents.ChatsGetSuccess);
    telemetry.timing(ETelemetryEvents.ChatsGetTime, Date.now() - startTime);

    return response.chats.map(mapChatV2VersionToV1) || [];
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatsGetFail);

    logger.error(
      {
        ...error,
        domain: DOMAIN,
        details: {
          ...error.details,
          microserviceName: 'chats',
          pathApi: '/v2/web/chats/get/',
          parameters: JSON.stringify(options),
          cookies,
        },
      },
      { degradation: 'Получение списка чатов' },
    );

    return null;
  }
}
